<template>
    <section class="home-container" style="height: 100%;">
<!--        <span v-if="dataListModel.dataList.length === 0">患者为首诊，无历史诊断</span>-->
        <div v-if="dataListModel.dataList.length === 0">患者为首诊，无历史诊断</div>
        <Table stripe="" :columns="columns10" :data="dataListModel.dataList" v-else>
        </Table>
    </section>
</template>
<script>
    import expandRow from './diagnose-history-simple-table-expand.vue'
    import Moment from 'moment'
    import PatientInfoModule from './patient-info-module'
    import PatientDiagnose from './patient_diagnose.vue'
    export default {
        components: {
            expandRow
        },
        props: {
            patientDetailsModel: {
                type: Object,
                default: null
            },
        },
        data() {
            return {
                user: null,
                moment: Moment,
                columns10: [
                    {
                        type: 'expand',
                        width: 50,
                        // 点击后调用接口查询相关数据
                        render: (h, params) => {
                            return h(expandRow, {
                                props: {
                                    user: this.user,
                                    row: this.dataListModel.dataList[params.index]
                                }
                            })
                        }
                    },
                    // {
                    //     title: '病历填写时间',
                    //     key: 'createTime',
                    //     render: (h, params) => {
                    //         if (this.checkValue(this.dataListModel.dataList[params.index].medicalRecordVO.createTime)) {
                    //             return h('span', '--')
                    //         }
                    //         return h('span', this.moment(this.dataListModel.dataList[params.index].medicalRecordVO.createTime).format('YYYY-MM-DD HH:mm:ss'))
                    //     }
                    // },
                    {
                        title: '就诊时间',
                        key: 'medicalRecordOrdermedicalRecordOrder',
                        render: (h, params) => {
                            if (this.checkValue(this.dataListModel.dataList[params.index].createTime)) {
                                return h('span', '未诊断')
                            }
                            return h('span', this.moment(this.dataListModel.dataList[params.index].createTime).format('YYYY-MM-DD HH:mm:ss'))
                        }
                    },
                    {
                        title: '诊断',
                        key: 'content',
                        render: (h, params) => {
                            return h('span', this.dataListModel.dataList[params.index].content)
                        }
                    },
                    {
                        title: '接诊人员',
                        render: (h, params) => {
                            return h('span', this.dataListModel.dataList[params.index].createUser)
                        }
                    },
                    // {
                    //     title: '类型',
                    //     key: 'isDeleted',
                    //     width: '80',
                    //     render: (h, params) => {
                    //         if (this.dataListModel.dataList[params.index].medicalRecordVO.isFirst) {
                    //             return h('span', '首诊')
                    //         } else {
                    //             return h('span', '随诊')
                    //         }
                    //     }
                    // },
                    // {
                    //     title: '下次诊断时间',
                    //     align: 'center',
                    //     render: (h, params) => {
                    //         // diagnoseTime
                    //         if (this.checkValue(this.dataListModel.dataList[params.index].medicalRecordVO.medicalRecordOrder) || this.checkValue(this.dataListModel.dataList[params.index].medicalRecordVO.medicalRecordOrder.diagnoseTime)) {
                    //             return h('span', '--')
                    //         }
                    //         return h('span', this.moment(this.dataListModel.dataList[params.index].medicalRecordVO.medicalRecordOrder.diagnoseTime).format('YYYY-MM-DD '))
                    //     }
                    // }
                ],
                data9: [
                    {
                        createTime: 'John Brown',
                        medicalRecordOrdermedicalRecordOrder: 18,
                        isDeleted: 'New York No. 1 Lake Park',
                        job: 'Data engineer',
                        interest: 'badminton',
                        birthday: '1991-05-14',
                        book: 'Steve Jobs',
                        movie: 'The Prestige',
                        music: 'I Cry'
                    },
                    {
                        createTime: 'Jim Green',
                        medicalRecordOrdermedicalRecordOrder: 25,
                        isDeleted: 'London No. 1 Lake Park',
                        job: 'Data Scientist',
                        interest: 'volleyball',
                        birthday: '1989-03-18',
                        book: 'My Struggle',
                        movie: 'Roman Holiday',
                        music: 'My Heart Will Go On'
                    },
                    {
                        createTime: 'Jim Green',
                        medicalRecordOrdermedicalRecordOrder: 28,
                        isDeleted: 'London No. 1 Lake Park',
                        job: 'Data Product Manager',
                        interest: 'tennis',
                        birthday: '1992-01-31',
                        book: 'Win',
                        movie: 'Jobs',
                        music: 'Don’t Cry'
                    },
                    {
                        createTime: 'Jim Green',
                        medicalRecordOrdermedicalRecordOrder: 29,
                        isDeleted: 'London No. 1 Lake Park',
                        job: 'Data Analyst',
                        interest: 'snooker',
                        birthday: '1988-7-25',
                        book: 'A Dream in Red Mansions',
                        movie: 'A Chinese Ghost Story',
                        music: 'actor'
                    }
                ],
                diagnosisModel: {
                    openDiagnosis: false,
                    diagnosisData: {
                        doctorAdviceId: '',
                        content: '',
                    }, // 处方数据对象
                    patientData: {}, // 患者数据对象
                    dietPlanData: {
                        dietPlanTableColumns: [
                            {
                                title: '时间',
                                width: 60,
                                align: 'center',
                                ellipsis: true,
                                tooltip: true,
                                render: (h, params) => {
                                    let week = ['早', '午', '晚', '加']
                                    return h("span", week[params.index] + "餐")
                                }
                            },
                            {
                                title: '周天',
                                align: 'center',
                                render: (h, params) => {
                                    let code = 6 + "" + (params.index + 1)
                                    let hList = []
                                    if (this.diagnosisModel.dietPlanData.dietPlanList != null) {
                                        this.diagnosisModel.dietPlanData.dietPlanList.infoVOList.forEach(function (infoVO) {
                                            if (infoVO.type == code) {
                                                infoVO.infoList.forEach(function (info) {
                                                    if (info.remark.length <= 0) {
                                                        hList.push(h("div", info.foodMaterial.name + info.value + info.foodMaterial.unit))
                                                    } else {
                                                        hList.push(h("div", info.foodMaterial.name + info.value + info.foodMaterial.unit + "(" + info.remark + ")"))
                                                    }
                                                })
                                                return
                                            }
                                        })
                                    }
                                    return h("div", hList)
                                }
                            },
                            {
                                title: '周一',
                                align: 'center',
                                ellipsis: true,
                                tooltip: true,
                                render: (h, params) => {
                                    let code = 0 + "" + (params.index + 1)
                                    let hList = []
                                    if (this.diagnosisModel.dietPlanData.dietPlanList != null) {
                                        this.diagnosisModel.dietPlanData.dietPlanList.infoVOList.forEach(function (infoVO) {
                                            if (infoVO.type == code) {
                                                infoVO.infoList.forEach(function (info) {
                                                    if (info.remark.length <= 0) {
                                                        hList.push(h("div", info.foodMaterial.name + info.value + info.foodMaterial.unit))
                                                    } else {
                                                        hList.push(h("div", info.foodMaterial.name + info.value + info.foodMaterial.unit + "(" + info.remark + ")"))
                                                    }
                                                })
                                                return
                                            }
                                        })
                                    }
                                    return h("div", hList)
                                }
                            },
                            {
                                title: '周二',
                                align: 'center',
                                render: (h, params) => {
                                    let code = 1 + "" + (params.index + 1)
                                    let hList = []
                                    if (this.diagnosisModel.dietPlanData.dietPlanList != null) {
                                        this.diagnosisModel.dietPlanData.dietPlanList.infoVOList.forEach(function (infoVO) {
                                            if (infoVO.type == code) {
                                                infoVO.infoList.forEach(function (info) {
                                                    if (info.remark.length <= 0) {
                                                        hList.push(h("div", info.foodMaterial.name + info.value + info.foodMaterial.unit))
                                                    } else {
                                                        hList.push(h("div", info.foodMaterial.name + info.value + info.foodMaterial.unit + "(" + info.remark + ")"))
                                                    }
                                                })
                                                return
                                            }
                                        })
                                    }
                                    return h("div", hList)
                                }
                            },
                            {
                                title: '周三',
                                align: 'center',
                                render: (h, params) => {
                                    let code = 2 + "" + (params.index + 1)
                                    let hList = []
                                    if (this.diagnosisModel.dietPlanData.dietPlanList != null) {
                                        this.diagnosisModel.dietPlanData.dietPlanList.infoVOList.forEach(function (infoVO) {
                                            if (infoVO.type == code) {
                                                infoVO.infoList.forEach(function (info) {
                                                    if (info.remark.length <= 0) {
                                                        hList.push(h("div", info.foodMaterial.name + info.value + info.foodMaterial.unit))
                                                    } else {
                                                        hList.push(h("div", info.foodMaterial.name + info.value + info.foodMaterial.unit + "(" + info.remark + ")"))
                                                    }
                                                })
                                                return
                                            }
                                        })
                                    }
                                    return h("div", hList)
                                }
                            },
                            {
                                title: '周四',
                                align: 'center',
                                render: (h, params) => {
                                    let code = 3 + "" + (params.index + 1)
                                    let hList = []
                                    if (this.diagnosisModel.dietPlanData.dietPlanList != null) {
                                        this.diagnosisModel.dietPlanData.dietPlanList.infoVOList.forEach(function (infoVO) {
                                            if (infoVO.type == code) {
                                                infoVO.infoList.forEach(function (info) {
                                                    if (info.remark.length <= 0) {
                                                        hList.push(h("div", info.foodMaterial.name + info.value + info.foodMaterial.unit))
                                                    } else {
                                                        hList.push(h("div", info.foodMaterial.name + info.value + info.foodMaterial.unit + "(" + info.remark + ")"))
                                                    }
                                                })
                                                return
                                            }
                                        })
                                    }
                                    return h("div", hList)
                                }
                            },
                            {
                                title: '周五',
                                align: 'center',
                                render: (h, params) => {
                                    let code = 4 + "" + (params.index + 1)
                                    let hList = []
                                    if (this.diagnosisModel.dietPlanData.dietPlanList != null) {
                                        this.diagnosisModel.dietPlanData.dietPlanList.infoVOList.forEach(function (infoVO) {
                                            if (infoVO.type == code) {
                                                infoVO.infoList.forEach(function (info) {
                                                    if (info.remark.length <= 0) {
                                                        hList.push(h("div", info.foodMaterial.name + info.value + info.foodMaterial.unit))
                                                    } else {
                                                        hList.push(h("div", info.foodMaterial.name + info.value + info.foodMaterial.unit + "(" + info.remark + ")"))
                                                    }
                                                })
                                                return
                                            }
                                        })
                                    }
                                    return h("div", hList)
                                }
                            },
                            {
                                title: '周六',
                                key: 'age',
                                align: 'center',
                                render: (h, params) => {
                                    let code = 5 + "" + (params.index + 1)
                                    let hList = []
                                    if (this.diagnosisModel.dietPlanData.dietPlanList != null) {
                                        this.diagnosisModel.dietPlanData.dietPlanList.infoVOList.forEach(function (infoVO) {
                                            if (infoVO.type == code) {
                                                infoVO.infoList.forEach(function (info) {
                                                    if (info.remark.length <= 0) {
                                                        hList.push(h("div", info.foodMaterial.name + info.value + info.foodMaterial.unit))
                                                    } else {
                                                        hList.push(h("div", info.foodMaterial.name + info.value + info.foodMaterial.unit + "(" + info.remark + ")"))
                                                    }
                                                })
                                                return
                                            }
                                        })
                                    }
                                    return h("div", hList)
                                }
                            },
                        ],
                        itemSet: [{
                            dataTime: '早餐',
                            sev: '01',
                            one: '11',
                            tow: '21',
                            thr: '31',
                            fou: '41',
                            fiv: '51',
                            six: '61'
                        },
                            {
                                dataTime: '午餐',
                                sev: '02',
                                one: '12',
                                tow: '22',
                                thr: '32',
                                fou: '42',
                                fiv: '52',
                                six: '62'
                            },
                            {
                                dataTime: '晚餐',
                                sev: '03',
                                one: '13',
                                tow: '23',
                                thr: '33',
                                fou: '43',
                                fiv: '53',
                                six: '63'
                            },
                            {
                                dataTime: '加餐',
                                sev: '04',
                                one: '14',
                                tow: '24',
                                thr: '34',
                                fou: '44',
                                fiv: '54',
                                six: '64',
                            }],
                        dietPlanList: {
                            infoVOList: []
                        },
                    }, // 饮食计划数据对象
                    nutritionalGoalData: {
                        nutritionalGoalTableColumns: [
                            {
                                type: 'index',
                                width: 80,
                                align: 'center',
                            },
                            {
                                title: '营养物质',
                                align: 'center',
                                ellipsis: true,
                                tooltip: true,
                                render: (h, params) => {
                                    let item = params.row
                                    return h("span", item.nutritionType.name + '（' + item.nutritionType.forShort + '）- ' + item.nutritionType.englishName)
                                },
                            },
                            {
                                title: '含量',
                                align: 'center',
                                ellipsis: true,
                                tooltip: true,
                                render: (h, params) => {
                                    let item = params.row
                                    return h("span", item.value + ' ' + item.nutritionType.unit)
                                },
                            },
                        ],//药物营养素表头
                        nutritionalGoalList: {
                            nutritionalGoalInfos: []
                        }
                    }, // 营养目标数据对象
                    dietGuidelinesData: {
                        dietGuidelineColumns: [
                            {
                                type: 'index',
                                width: 80,
                                align: 'center',
                            },
                            {
                                title: '原则名称',
                                key: 'name',
                                align: 'center',
                                ellipsis: true,
                                tooltip: true
                            },
                            {
                                title: '原则描述',
                                key: 'description',
                                align: 'center',
                                ellipsis: true,
                                tooltip: true
                            },
                            {
                                title: '禁食界限',
                                align: 'center',
                                ellipsis: true,
                                tooltip: true,
                                render: (h, params) => {
                                    if (params.row.detailList.length === 0) {
                                        return
                                    }
                                    return h("span", params.row.detailList[0].name)
                                }
                            }
                        ],
                        dataList: [
                            {
                                id: '',
                                name: '',
                                description: '',
                                detailList: [],
                            }
                        ]
                    }, // 饮食原则数据对象
                    doctorAdviceData: {}, // 医嘱数据对象
                    medicalRecordData: {}, // 病历数据对象
                }, // 处方模型
                dataListModel: {
                    pageNum: 1,
                    pageSize: 20,
                    pageTotal: 0,
                    dataList: []
                },
                nutritionalGoalSearch: {},
                medicineUsage: [],
                itemIsFirst: true // 选中的历史是否是首诊
            }
        },
        methods: {
                async getDiagnoseHistoryList() {
                    this.$Message.loading('正在加载中。。。')

                    this.$http.post('prescription/list', {
                        userId: this.user.id,
                        isDeleted: false,
                        pageSize: this.dataListModel.pageSize,
                        pageNum: this.dataListModel.pageNum,
                    }).then(function (res) {
                        let msg = res.body
                        if (msg.success) {
                            this.dataListModel.dataList = msg.data.list
                            this.dataListModel.pageTotal = msg.data.total
                        } else {
                            this.$Notice.error({title: '处方列表查询失败', desc: msg.message});
                        }
                    }, function (res) {
                        this.myError(res.body)
                    })
                },
                checkValue(value) {
                    if (value === '' || value === null || value === undefined || value.length === 0) {
                        return true
                    }
                    return false
                }, // 空值判断
                // 根据生日获取年龄
                getAgeByBirthday(birthday) {
                    if (!birthday) {
                        return
                    }
                    let returnAge;
                    let strBirthdayArr = birthday.split("-");
                    let birthYear = strBirthdayArr[0];
                    let birthMonth = strBirthdayArr[1];
                    let birthDay = strBirthdayArr[2];

                    let d = new Date();
                    let nowYear = d.getFullYear();
                    let nowMonth = d.getMonth() + 1;
                    let nowDay = d.getDate();

                    if (nowYear == birthYear) {
                        returnAge = 0;//同年 则为0岁
                    } else {
                        let ageDiff = nowYear - birthYear; //年之差
                        if (ageDiff > 0) {
                            if (nowMonth == birthMonth) {
                                let dayDiff = nowDay - birthDay;//日之差
                                if (dayDiff < 0) {
                                    returnAge = ageDiff - 1;
                                } else {
                                    returnAge = ageDiff;
                                }
                            } else {
                                let monthDiff = nowMonth - birthMonth;//月之差
                                if (monthDiff < 0) {
                                    returnAge = ageDiff - 1;
                                } else {
                                    returnAge = ageDiff;
                                }
                            }
                        } else {
                            returnAge = -1;//返回-1 表示出生日期输入错误 晚于今天
                        }
                    }

                    return returnAge;//返回周岁年龄
                }
            },
        created() {
                this.$store.commit('setCurrentPatient', JSON.parse(sessionStorage.getItem('currentPatient')))
                this.user = this.$store.state.currentPatient
                if (this.user == null) {
                    this.$Notice.error({title: '数据异常，请重新登录'})
                    return
                }
                this.user['age'] = this.getAgeByBirthday(this.user.birthday)
                this.nutritionalGoalSearch.age = this.user.age
                this.nutritionalGoalSearch.sex = this.user.sex
                this.nutritionalGoalSearch.height = this.user.height
                this.nutritionalGoalSearch.weight = this.user.weight
                this.getDiagnoseHistoryList()
            }
        }
</script>